export enum ChartGridState {
  NOT_INITIALIZED,
  RESULT_NOT_FOUND,
  PROCESSING,
  RENDERING
}
